import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import Button from '@material-ui/core/Button';
import { navigate } from '@reach/router';
import { ADMIN_SHOP_FABRICS } from '../../gql/admin-queries';
import { ADMIN_CREATE_FABRIC_COMPOSITION } from '../../gql/admin-mutations';

class AddFabric extends Component {
  render() {
    const { shopId } = this.props;
    return (
      <Mutation
        mutation={ADMIN_CREATE_FABRIC_COMPOSITION}
        variables={{ shopId: shopId }}
        update={(cache, { data: { createFabricComposition } }) => {
          if (createFabricComposition.id) {
            navigate(
              `/admin/${shopId}/inventory/fabrics/${createFabricComposition.id}`
            );
          }
        }}
      >
        {addFabric => (
          <Button
            data-cy="Material-Add-New-btn"
            onClick={() => {
              addFabric();
            }}
            variant="outlined"
            color="primary"
            size="small"
          >
            New Material
          </Button>
        )}
      </Mutation>
    );
  }
}

export default AddFabric;
